export default "__VITE_ASSET__CB31zJaA__"